// Fallback falls APP_CONFIG nicht rechtzeitig gesetzt wurde
window.APP_CONFIG = window.APP_CONFIG || {
    hCaptchaEnabled: false,
    reCaptchaEnabled: false,
    friendlyCaptchaEnabled: false,
    friendlyCaptchaV1Enabled: false
}

const services = []

// Technisch notwendiger Basisdienst (immer sichtbar)
services.push({
    name: 'essential',
    title: 'Technisch erforderlich',
    purposes: ['security'],
    cookies: [],
    default: true,
    required: true,
    optOut: false,
    onlyOnce: true
})

// friendlyCaptcha-Dienst (optional)
if (window.APP_CONFIG.friendlyCaptchaEnabled === true) {
    services.push({
        name: 'Friendly Captcha',
        title: 'Friendly Captcha',
        purposes: ['security'],
        cookies: [],
        default: true,
        required: false,
        optOut: false,
        onlyOnce: true,
        callback: function (consent) {
            if (consent) {
                const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')

                if (window.APP_CONFIG.friendlyCaptchaV1Enabled === true) {
                    // V1:  
                    const script = document.createElement('script');
                    script.type = 'module';
                    script.src = '/assets/vendor/friendlycaptcha/v1/widget.module.min.js';
                    script.async = true;
                    script.defer = true;
                    if (nonce) script.setAttribute('nonce', nonce);
                    document.head.appendChild(script)
                } else {
                    // V2: 
                    // Load the script dynamically from your local asset path
                    const script = document.createElement('script');
                    script.type = 'module';
                    script.src = '/assets/vendor/friendlycaptcha/v2/site.min.js';
                    script.async = true;
                    script.defer = true;
                    if (nonce) script.setAttribute('nonce', nonce);
                    document.head.appendChild(script);
                }
            }
        }
    })
}

// hCaptcha-Dienst (optional)
if (window.APP_CONFIG.hCaptchaEnabled === true) {
    services.push({
        name: 'hcaptcha',
        title: 'hCaptcha',
        purposes: ['security'],
        cookies: [],
        default: true,
        required: false,
        optOut: false,
        onlyOnce: true,
        callback: function (consent) {
            if (consent) {
                const script = document.createElement('script')
                script.src = 'https://hcaptcha.com/1/api.js'
                script.async = true
                script.defer = true
                const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')
                if (nonce) script.setAttribute('nonce', nonce)
                document.head.appendChild(script)
            }
        }
    })
}

// reCAPTCHA-Dienst (optional)
if (window.APP_CONFIG.reCaptchaEnabled === true) {
    services.push({
        name: 'recaptcha',
        title: 'Google reCAPTCHA',
        purposes: ['security'],
        cookies: [],
        default: true,
        required: false,
        optOut: false,
        onlyOnce: true,
        callback: function (consent) {
            if (consent) {
                const script = document.createElement('script')
                script.src = 'https://www.google.com/recaptcha/api.js'
                script.async = true
                script.defer = true
                const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')
                if (nonce) script.setAttribute('nonce', nonce)
                document.head.appendChild(script)
            }
        }
    })
}

const klaroConfig = {
    version: 1,
    elementID: 'klaro',
    cookieName: 'klaro-consent',
    htmlTexts: true,
    embedded: false,
    storageMethod: 'localStorage',
    default: false,
    mustConsent: true,
    acceptAll: true,
    hideDeclineAll: false,
    lang: 'de',
    useNonce: true,
    nonce: document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content'),

    translations: {
        de: {
            consentModal: {
                title: 'Datenschutzeinstellungen',
                description: 'Hier kannst du einsehen und anpassen, welche externen Dienste wir auf dieser Website verwenden.',
            },
            consentNotice: {
                description: 'Wir verwenden Cookies und externe Dienste zur Verbesserung der Funktionalität. Du kannst dies jederzeit anpassen.',
                learnMore: 'Einstellungen',
            },
            purposes: {
                security: 'Sicherheit (z. B. Captcha-Schutz)',
            },
            services: {
                essential: {
                    title: 'Technisch erforderlich',
                    description: 'Wird benötigt, um die Seite grundlegend nutzbar zu machen.',
                },
                hcaptcha: {
                    title: 'hCaptcha',
                    description: 'Wird verwendet, um Formulare vor Spam und Bots zu schützen.',
                },
                recaptcha: {
                    title: 'Google reCAPTCHA',
                    description: 'Google CAPTCHA zur Spamabwehr. Es können Daten in die USA übertragen werden.',
                }
            }
        }
    },

    services // ⬅️ das neue Format
}

export default klaroConfig;